<template>
    <div class="administration">
        <div class="administration-login" v-if="statusChecked">
            <img src="/static/img/admin/logo.png" alt="Alcomet administration">
            <form class="administration-login-form" @submit.prevent="login">
                <!-- <label>Username</label> -->
                <input class="administration-input" required v-model="user.username" type="text" placeholder="Потребител"/>
                <!-- <label>Password</label> -->
                <input class="administration-input" required v-model="user.password" type="password" placeholder="Парола"/>
                <button class="administration-submit" type="submit">Вход</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      statusChecked: false,
      user: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    login() {
      new Promise((resolve, reject) => {
        this.$http({
          url: `${process.env.ROOT_API}/admin/login`,
          data: this.user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.token;
            localStorage.setItem("token", token); // store the token in localstorage
            resolve(resp);
          })
          .catch(err => {
            localStorage.removeItem("token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      }).then(() => {
        this.isLoggedIn();
        this.user = {
          username: "",
          password: ""
        };
      });
    },
    isLoggedIn() {
      this.statusChecked = false;
      const token = localStorage.getItem("token");
      this.$http({
        url: `${process.env.ROOT_API}/admin/validate`,
        data: { token: token },
        method: "POST"
      })
        .then(res => {
          if (res.data.user) {
            // this.currentlyLoggedUser = res.data.user;
            this.$router.push("/admin");
          } else {
            this.statusChecked = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.statusChecked = true;
        });
    }
  },
  mounted() {
    this.isLoggedIn();
    console.log(process.env.ROOT_API)
  }
};
</script>

<style scoped>
.administration {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  min-width: 1000px;
}
.administration-login {
  align-items: center;
  background-image: url("/static/img/admin/bg.jpg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100%;
}
.administration-login-form {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 15px;
}
.administration-input,
.administration-submit {
  color: #000;
  height: 50px;
  margin: 5px 0;
  width: 280px;
}
.administration-input {
  padding: 0 15px;
}
.administration-submit {
  background-color: #2ea4d7;
  border: none;
  color: #fff;
  cursor: pointer;
  display: block;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.administration-submit:hover {
  background-color: #3099c6;
}
.administration-panel {
  min-height: 100vh;
  width: 100%;
}
.administration-header {
  align-items: center;
  background-color: #2ea4d7;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding-left: 40px;
  width: 100%;
}
.administration-header p {
  color: #fff;
}
.administration-logout {
  align-items: center;
  background-color: #2ea4d7;
  color: #fff;
  display: flex;
  height: 100%;
  padding: 0 40px;
}
.administration-logout:hover {
  background-color: #3099c6;
}
.administration-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 40px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/administration/AdministrationLogin.vue